// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__1Fra7","icon":"IconButton_icon__tqpA5","mini":"IconButton_mini__BTIVe","adaptive":"IconButton_adaptive__i8lZ-"};